import IconArrowBack from '@/components/icons/arrowBack.vue'
import IconBase from '@/components/IconBase.vue'
import IconForward from '@/components/icons/arrowForward.vue'
import IconCheck from '@/components/icons/check.vue'


export default {
    $_veeValidate: {
      validator: 'new'
    },
    name: "ServiceAuthorisedRepresentive",
    components: {
        IconArrowBack,
        IconBase,
        IconForward,
        IconCheck
    },
    data() {
        return {
            rep_first_name: "",
            rep_last_name: "",
            dictionary: {
                custom: {
                    rep_first_name: {
                        required: () => 'First name is required to proceed',
                        max: 'Cannot exceed more than 60 characters'
                    },
                    rep_last_name: {
                        required: () => 'Last name is required to proceed',
                        max: 'Cannot exceed more than 60 characters'
                    },
                }
            }
        }
    },
    methods: {
        ValidateRepName() {
            this.$validator.validateAll().then((result) => {
                if(result) {
                    this.$parent.ServiceInsuranceProcess.rep_first_name = this.rep_first_name;
                    this.$parent.ServiceInsuranceProcess.rep_last_name = this.rep_last_name;
                    this.$parent.ServiceNextStep(2,"NumberOfEducators");
                } else {
                    console.error("There seems to be an error in your entries");
                }
            });
        },
        ValidateSessionData() {
            if(this.$parent.ServiceInsuranceProcess.rep_first_name != null) {
                this.rep_first_name = this.$parent.ServiceInsuranceProcess.rep_first_name;
                this.rep_last_name = this.$parent.ServiceInsuranceProcess.rep_last_name;
                this.$validator.validateAll(); /* this was added to add success state on fields and buttons */
            }
        }
    },
    computed: {
        AllFieldsValid: function() {
            let _isvalid = false;
            let fld = this.fields;
            if(fld.rep_first_name && fld.rep_last_name) {
                if(fld.rep_first_name.valid && fld.rep_first_name.valid) { _isvalid = true; }
            }

            return _isvalid;
        }
    },
    mounted () {
        this.$validator.localize('en', this.dictionary);
        this.$parent.CheckWindowPathName();
        this.$parent.isContinueActive = false;
        this.ValidateSessionData();
        this.$parent.CurrentProcess = "ServiceInsuranceProcess";
    }
}